const KEY = "wegli-quick:apiKey";

export function getApiKey(): string {
  return localStorage.getItem(KEY) ?? "";
}

export function setApiKey(value: string): void {
  const trimmed = value.trim();
  if (trimmed) localStorage.setItem(KEY, trimmed);
  else localStorage.removeItem(KEY);
}

export function hasApiKey(): boolean {
  return getApiKey().length > 0;
}
